import {getCookie} from "@pg-mono/request";

export const getGaUserId = () => {
    const gaCookie = getCookie("_ga");
    return gaCookie ? gaCookie.split(".").slice(2).join(".") : null;
};
import {getCookie} from "@pg-mono/request";

export const getGaUserId = () => {
    const gaCookie = getCookie("_ga");
    return gaCookie ? gaCookie.split(".").slice(2).join(".") : null;
};
